import _ from 'lodash'

// eslint-disable-next-line
export const prepareTableData = (data) => {
    return {
        _table: _.reduce(
            data,
            (acc, row) => {
                const value = _.get(row, 'value', null)
                const text = _.get(row, 'text', null)
                const equity = _.get(row, 'equity', null)
                const registeredCapital = _.get(row, 'registeredCapital', null)
                const categoryText = _.get(row, 'category.text', null)

                return [
                    ...acc,
                    {
                        text,
                        value,
                        equity,
                        registeredCapital,
                        categoryText,
                    },
                ]
            },
            []
        ),
    }
}
